import * as React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import MaterialTable, { Column } from 'material-table';
import Fab from '@material-ui/core/Fab';
import AutorenewIcon from '@material-ui/icons/Autorenew';
import { Tooltip, Dialog, DialogContent, WithStyles, withStyles, Typography, IconButton, DialogActions, Button } from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import { MyInvoicesData } from 'src/reducers/paidinvoice';
import CloseIcon from '@material-ui/icons/Close';
import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import FilterListIcon from '@material-ui/icons/FilterList';
import PrintIcon from '@material-ui/icons/Print';

interface TableState {
    columns: Array<Column<MyInvoicesData>>;
    data: MyInvoicesData[];
}

export interface MyInvoicesViewProps {
    myInvoicesData: MyInvoicesData[];
    dateFilter: (filterStartdate: Date, filterEnddate: Date) => void;
    dateReset: (filterStartdate: Date, filterEnddate: Date) => void;
    printTxn: (txn: String, type: String) => void;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
            height: 'calc(90vh - 64px)'
        },
        table: {
            // margin: theme.spacing(1),
            minWidth: 500,
        },
        iconbutton: {
            display: 'flex',
            '& > *': {
                margin: theme.spacing(1),
            },
            justifyContent: 'center'
        },
        color: {
            backgroundColor: '#23a710e6',
            color: '#fff'
        },
        paymentButton: {
            // margin: theme.spacing(1),
            float: 'right',
            zIndex: 100,
            // margin: '12px',
            position: 'absolute',
            right: 0,
            backgroundColor: 'transparent',
            boxShadow: 'none',
            '&:hover': {
                backgroundColor: 'transparent',
                boxShadow: 'none',
            }
        },
        dialogContent: {
            textAlign: 'center',
            fontWeight: 'bolder',
            fontSize: '50px'
        },
        dialogContentAlert: {
            textAlign: 'center',
            fontWeight: 'bolder',
            fontSize: '30px'
        },
        money: {
            color: '#8bc34a',
            fontSize: 40,
            margin: '0 5px',
        },
        dialogTitle: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '10px'
        },
        dialogAction: {
            justifyContent: 'center',
        },
        iconClose: {
            position: 'absolute',
            right: 0
        },
        underline: {
            textDecoration: 'underline',
            textTransform: 'uppercase'
        },
        right: {
            textAlign: 'right',
            fontWeight: 500,
            fontSize: '25px',
            color: '#212121'
        },
        left: {
            textAlign: 'left',
            fontWeight: 500,
            fontSize: '25px',
            color: '#212121bd'
        },
        popTitle: {
            color: '#3F51B5'
        },
        buttonSend: {
            // margin: theme.spacing(1),
            float: 'right',
            zIndex: 100,
            margin: '12px',
            position: 'relative'
        },
        HeadinG: {
            margin: theme.spacing(1),
            '& .MuiInputBase-input': {
                fontSize: '0.9rem'
            },
            '& .MuiButton-label': {
                fontSize: '0.7rem'
            },
            fontSize: '0.9rem'
        }
    })
);

const styles = (theme: Theme) =>
    createStyles({
        root: {
            margin: 0,
            padding: theme.spacing(2),
        },
        closeButton: {
            position: 'absolute',
            right: theme.spacing(1),
            top: theme.spacing(1),
            color: theme.palette.grey[500],
        },
    });

export interface DialogTitleProps extends WithStyles<typeof styles> {
    id: string;
    children: React.ReactNode;
    onCloseD: () => void;
}

const DialogTitle = withStyles(styles)((propss: DialogTitleProps) => {
    const { children, onCloseD, classes, ...other } = propss;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onCloseD ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onCloseD}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

// const CssTextField = withStyles({
//     root: {
//         '& .MuiInputBase-root.Mui-disabled': {
//             color: '#000',
//         },
//     },
// })(TextField);

export const MyInvoicesView: React.StatelessComponent<MyInvoicesViewProps> = (props) => {
    const classes = useStyles({});

    // const [fullWidth] = React.useState(true);
    // const [maxWidth] = React.useState<DialogProps['maxWidth']>('md');

    // const [dialogData, setDialogData] = React.useState<MyInvoicesData>();

    // const [viewInvoiceOpen, setViewInvoice] = React.useState(false);
    // const onCloseViewInvoice = () => {
    //     setViewInvoice(false);
    // };

    // const onViewInvoice = (data: MyInvoicesData) => {
    //     setDialogData(data);
    //     setViewInvoice(true);
    // };

    const [dialogOpen, setdialogOpen] = React.useState(true);
    const [filterStartdate, setFilterStartDate] = React.useState(new Date(new Date().getTime() - (7 * 24 * 60 * 60 * 1000)));
    const [filterEnddate, setFilterEndDate] = React.useState(new Date());

    const changeStartDate = (date: Date) => {
        setFilterStartDate(date);
    };
    const changeEndDate = (date: Date) => {
        setFilterEndDate(date);
    };

    const handleClickDialog = () => {
        setdialogOpen(true);
    };

    const handleCloseDialog = () => {
        setdialogOpen(false);
    };

    const submitDialog = () => {
        props.dateFilter(filterStartdate, filterEnddate);
        setdialogOpen(false);
    };
    const reload = () => {
        props.dateFilter(filterStartdate, filterEnddate);
    };
    const resetDialog = () => {
        props.dateReset(new Date(new Date().getTime() - (7 * 24 * 60 * 60 * 1000)), new Date());
        setdialogOpen(false);
    };

    const [state] = React.useState<TableState>({
        columns: [
            { title: 'Invoice No', field: 'docid' },
            { title: 'Invoice Date', field: 'docdate' },
            { title: 'Type', field: 'doctype' },
            { title: 'Order No', field: 'orderno' },
            { title: 'TAT', field: 'tattype' },
            { title: 'Total Units', field: 'totunit' },
            { title: 'Invoice Amount', field: 'totalnetamount', render: rowData => (`$ ${parseFloat(rowData.totalnetamount) || '0'}`) },
            {
                title: 'Action',
                field: 'fdownload',
                export: false,
                render: rowData => (
                    <div style={{ display: 'flex' }}>
                        <Tooltip title="Print" placement="top">
                            <IconButton aria-label="view" onClick={() => props.printTxn(rowData.docid, rowData.doctype)}>
                                <PrintIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    </div>
                ),
                cellStyle: {
                    padding: '0px'
                }
            }
        ],
        data: props.myInvoicesData
    });
    // // ==> console.error(props.isWaiting, 'four');
    return (
        <div className={classes.root}>
            <Grid container justify="center" alignItems="center" >
                <Grid item xs={12} sm={12} md={12}>
                    <div>
                        <Tooltip title="Refresh" placement="top" arrow>
                            <Fab color="primary" aria-label="add" style={{ height: '40px', width: '40px', float: 'left', margin: '12px', zIndex: 100 }} onClick={reload}>
                                <AutorenewIcon />
                            </Fab>
                        </Tooltip>
                        <Tooltip title="Filter" placement="top" arrow>
                            <Button
                                id="filterDate"
                                aria-controls="customized-menu"
                                aria-haspopup="true"
                                variant="contained"
                                color="primary"
                                onClick={handleClickDialog}
                                className={classes.buttonSend}
                            >
                                <FilterListIcon />
                            </Button>
                        </Tooltip>
                        <MaterialTable
                            title="My Invoices"
                            columns={state.columns}
                            data={props.myInvoicesData}
                            localization={{
                                header: {
                                    actions: ''
                                }
                            }}
                            options={{
                                pageSizeOptions: [5, 10, 25, 50, 100],
                                sorting: true,
                                actionsColumnIndex: -1,
                                headerStyle: {
                                    backgroundColor: '#757575',
                                    color: '#fff',
                                    padding: '5px 10px',
                                }
                            }}
                        />
                    </div>
                </Grid>
            </Grid>
            {/* <Dialog
                open={viewInvoiceOpen}
                fullWidth={fullWidth}
                maxWidth={maxWidth}
                onClose={onCloseViewInvoice}
            >
                <DialogTitle id="form-dialog-title-viewInvoice" onCloseD={onCloseViewInvoice}>
                    Transaction Details for Ref No: <span className={classes.popTitle}>{typeof (dialogData) === 'object' ? dialogData.refno : ''}</span>
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <CssTextField
                                size="small"
                                fullWidth
                                label="Receipt No"
                                disabled
                                value={typeof (dialogData) === 'object' ? dialogData.docid : ''}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <CssTextField
                                size="small"
                                fullWidth
                                label="Reference No"
                                disabled
                                value={typeof (dialogData) === 'object' ? dialogData.refno : ''}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <CssTextField
                                size="small"
                                fullWidth
                                label="Transaction Amount"
                                disabled
                                value={typeof (dialogData) === 'object' ? dialogData.paidamt : ''}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <CssTextField
                                size="small"
                                fullWidth
                                label="Paid On"
                                disabled
                                value={typeof (dialogData) === 'object' ? dialogData.docdate : ''}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <CssTextField
                                size="small"
                                fullWidth
                                label="Mode of Payment"
                                disabled
                                value={typeof (dialogData) === 'object' ? dialogData.paymode : ''}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog> */}
            <Dialog
                open={dialogOpen}
                onClose={handleCloseDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="filter-myinvoices-title" onCloseD={handleCloseDialog}><Typography style={{ textAlign: 'center', fontWeight: 'bold' }}>Date Filter</Typography></DialogTitle>
                <DialogContent>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <div>
                            <Grid container justify="space-around" spacing={2}>
                                <KeyboardDatePicker
                                    margin="normal"
                                    id="date-picker-dialog"
                                    label="Start Date"
                                    format="MM/dd/yyyy"
                                    value={filterStartdate}
                                    onChange={changeStartDate}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                />
                            </Grid>
                            <Grid container justify="space-around" spacing={2}>
                                <KeyboardDatePicker
                                    margin="normal"
                                    id="date-picker-dialog-2"
                                    label="End Date"
                                    format="MM/dd/yyyy"
                                    value={filterEnddate}
                                    onChange={changeEndDate}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                />
                            </Grid>
                        </div>
                    </MuiPickersUtilsProvider>
                </DialogContent>
                <DialogActions>
                    <Button
                        type="button"
                        variant="outlined"
                        color="primary"
                        className={classes.HeadinG}
                        onClick={submitDialog}
                    >
                        Submit
                    </Button>
                    <Button
                        type="button"
                        variant="outlined"
                        color="secondary"
                        onClick={resetDialog}
                        className={classes.HeadinG}
                    >
                        Reset
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default MyInvoicesView;



// WEBPACK FOOTER //
// ./src/components/layouts/MyInvoicesView.tsx